/**
 * WordPress dependencies.
 */
import { Icon } from '@wordpress/components';
import { floor } from 'lodash';

const showRatingStar = ( attributes ) => {
	const { rating, blockAdvanceOptions } = attributes;
	const starStyle = blockAdvanceOptions?.starStyle ? blockAdvanceOptions.starStyle : 'default';
	const maxRating = blockAdvanceOptions?.maxRating ? blockAdvanceOptions.maxRating : 5;

	const filledRating = floor( rating );
	const hasHalf = rating % 1 !== 0;
	let emptyRating = maxRating - filledRating;
	emptyRating = hasHalf && emptyRating > 0 ? emptyRating - 1 : emptyRating;
	let stars = [];
	for ( let rIndex = 0; rIndex < filledRating; rIndex++ ) {
		let iconName = 'thumbs-up' === starStyle ? 'fas fa-thumbs-up' : 'fas fa-star';
		iconName = 'thumbs-up-fill' === starStyle ? 'fas fa-thumbs-up' : iconName;
		iconName = 'smiley' === starStyle ? 'fas fa-smile' : iconName;
		iconName = 'smiley-fill' === starStyle ? 'fas fa-smile' : iconName;
		// stars = [ ...stars, <Icon icon={ iconName } className="gutenify-star-rating-filled" key={ `rating-filled-${ rIndex }` } /> ];
		stars = [ ...stars, <span className={ iconName + ' gutenify-star-rating-filled' } key={ `rating-filled-${ rIndex }` } /> ];
	}

	if ( hasHalf ) {
		let iconName = 'default-fill' === starStyle ? 'fas fa-star-half-alt' : 'fas fa-star-half-alt';
		iconName = 'thumbs-up' === starStyle ? 'fas fa-thumbs-up' : iconName;
		iconName = 'thumbs-up-fill' === starStyle ? 'fas fa-thumbs-up' : iconName;
		iconName = 'smiley' === starStyle ? 'fas fa-smile' : iconName;
		iconName = 'smiley-fill' === starStyle ? 'fas fa-smile' : iconName;
		// stars = [ ...stars, <Icon icon={ iconName } className="gutenify-star-rating-half" key="rating-half" /> ];
		stars = [ ...stars, <span className={ iconName + ' gutenify-star-rating-half' } key={ `rating-half` } /> ];
	}

	if ( emptyRating > 0 && 'just-marked' !== starStyle ) {
		for ( let rIndex = 0; rIndex < emptyRating; rIndex++ ) {
			let iconName = 'default-fill' === starStyle ? 'fas fa-star' : 'far fa-star';
			iconName = 'thumbs-up' === starStyle ? 'far fa-thumbs-down' : iconName;
			iconName = 'thumbs-up-fill' === starStyle ? 'fas fa-thumbs-down' : iconName;
			iconName = 'smiley' === starStyle ? 'far fa-frown' : iconName;
			iconName = 'smiley-fill' === starStyle ? 'fas fa-frown' : iconName;
			stars = [ ...stars, <span className={ iconName + ' gutenify-star-rating-empty' } key={ `rating-empty-${ rIndex }` } /> ];
		}
	}

	return stars;
};

export { showRatingStar };
